import { ParkingCircle, Toilet, Info } from "lucide-react";

const dist = (f) => (f.distance_ft === 0 ? "at the trailhead" : f.distance_ft < 1000 ? `${f.distance_ft} ft away` : `${f.distance_mi} mi away`);

const Row = ({ icon: Icon, label, f, testid }) => (
  <div className="flex items-start gap-2" data-testid={testid}>
    <Icon className="w-3.5 h-3.5 text-primary mt-0.5 shrink-0" />
    <div className="min-w-0 text-xs">
      {f ? (
        <>
          <span className="font-semibold">{label}</span> <span className="text-muted-foreground">· {f.name && f.name !== label ? `${f.name}, ` : ""}{dist(f)}</span>
          {f.notes && <p className="text-muted-foreground">{f.notes}</p>}
        </>
      ) : <span className="text-muted-foreground">No {label.toLowerCase()} listed nearby</span>}
    </div>
  </div>
);

export function TrailheadFacilities({ facilities }) {
  if (!facilities) return null;
  const { notes, parking, restroom } = facilities;
  return (
    <div className="space-y-1.5 border-t border-primary/20 pt-2" data-testid="drive-route-facilities">
      {notes && (
        <div className="flex items-start gap-2 text-xs" data-testid="drive-route-trailhead-notes">
          <Info className="w-3.5 h-3.5 text-primary mt-0.5 shrink-0" /><p className="text-muted-foreground">{notes}</p>
        </div>
      )}
      <Row icon={ParkingCircle} label="Parking" f={parking} testid="drive-route-parking" />
      <Row icon={Toilet} label="Restroom" f={restroom} testid="drive-route-restroom" />
    </div>
  );
}
